export enum TemporaryAccesReasonType {
  Unknown = 'Unknown',
  Vacation = 'Vacation',
  Sickness = 'Sickness',
  Calamity = 'Calamity',
  Other = 'Other',
}
